import { TableService } from "../../shared/table/table.service";

export function isSicknessEventName(wordFullName: string): boolean {
  return !!wordFullName && /sickness/i.test(wordFullName);
}

/** Shared params when opening from e360 Add Event / type switch */
export type UnifiedEventParams = {
  employeeId?: number;
  employeeUid?: string;
  careHomeId?: number;
  tableIdentifier?: string;
  eventTypeId?: number;
  description?: string;
  firstDayAvailable?: any;
  // AL fields
  leavingStart?: any;
  leavingEnd?: any;
  alText?: string;
  events?: any[];
  employeeStatus?: string;
  // Sickness fields
  sicknessStart?: any;
  sicknessEnd?: any;
  needAcceptance?: boolean;
  unifiedEvent?: boolean;
};

export function openUnifiedSicknessForm(
  tableService: TableService,
  params: UnifiedEventParams,
): void {
  Promise.all([
    import("../sickness/new-sickness/new-sickness.component"),
    import("../sickness/new-sickness/new-sickness.overlay"),
  ]).then(([comp, overlay]) => {
    tableService.openNewWindowAndCloseThis(
      comp.NewSicknessComponent,
      "Add new event",
      overlay.NEW_SICKNESS_OVERLAY_CONFIG,
      {
        ...params,
        unifiedEvent: true,
        needAcceptance: false,
      },
    );
  });
}

export function openUnifiedAnnualLeaveForm(
  tableService: TableService,
  params: UnifiedEventParams,
): void {
  Promise.all([
    import(
      "../annual-leaving/new-annual-leaving/new-annual-leaving.component"
    ),
    import(
      "../annual-leaving/new-annual-leaving/new-annual-leaving.overlay"
    ),
  ]).then(([comp, overlay]) => {
    tableService.openNewWindowAndCloseThis(
      comp.NewAnnualLeavingComponent,
      "Add new event",
      overlay.NEW_ANNUAL_LEAVING_OVERLAY_CONFIG,
      {
        ...params,
        unifiedEvent: true,
      },
    );
  });
}
